import FitText from './fit-text';

export default FitText;
